// extracted by mini-css-extract-plugin
module.exports = {"listFeatures":"list-features-module--listFeatures--2wC4c"};